import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-dcos', 'IconBrandDcos', [
  ['path', { d: 'M3 18l18 -12h-18l9 14l9 -14v10l-18 -10z', key: 'svg-0' }],
]);
